import * as React from "react";
import { NoEntitiesExist } from "components/common";
import VulnerabilitiesInfo from "./VulnerabilitiesInfo";
import PortList from "./PortList";
import { NoEntitiesExistWrapper } from "../shared";
function Vulnerabilities({ asset }) {
  const allVulnerabilities = asset.vulnerabilities.reduce(
    (acc, vuln) => {
      (vuln.vulnerabilities || []).forEach((inVuln) => {
        if (!acc.find(
          (v) => `${v.vulnerability_id}${v.cve}` === `${inVuln.vulnerability_id}${inVuln.cve}`
        )) {
          acc.push({ ...inVuln, scannerType: vuln.scanner_type });
        }
      });
      return acc;
    },
    []
  );
  const allPorts = asset.vulnerabilities.reduce(
    (acc, vuln) => {
      (vuln.ports || []).forEach((inPort) => {
        if (!acc.find(
          (p) => `${p.port}${p.protocol}` === `${inPort.port}${inPort.protocol}`
        )) {
          acc.push(inPort);
        }
      });
      return acc;
    },
    []
  );
  if (allVulnerabilities.length === 0) {
    return /* @__PURE__ */ React.createElement(NoEntitiesExistWrapper, null, /* @__PURE__ */ React.createElement(NoEntitiesExist, null, "This asset doesn't have any vulnerabilities reported"));
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(VulnerabilitiesInfo, { vulnerabilities: allVulnerabilities }), /* @__PURE__ */ React.createElement("strong", null, "Ports"), /* @__PURE__ */ React.createElement(PortList, { ports: allPorts }));
}
export default Vulnerabilities;
